import { useEffect } from 'react';
import { useCompassCard } from '@scale/compass-ui/store';
import type { ChatBulkAuditResultsAdapterContext } from '@scale/genai-compass-shared/cards/chat_bulk_audit_results_adapter';
import { FilterGroup, isValidFilterGroup } from '@scale/compass-shared/filter';
import { CardType } from '@scale/genai-compass-shared/cardTypes';

function useChatBulkAuditResultsAdapterCard(index: number) {
  const { card, updateCardContext, updateCardCanSubmit, error } =
    useCompassCard<ChatBulkAuditResultsAdapterContext>(index);

  if (card.defaultContext.cardType !== CardType.CHAT_BULK_AUDIT_RESULTS_ADAPTER) {
    throw new Error('Invalid card type for ChatBulkAuditResultsAdapterCard');
  }

  const context = card.defaultContext;

  const setFilter = (filter: FilterGroup) => {
    const updatedContext: ChatBulkAuditResultsAdapterContext = {
      ...context,
      filter,
    };
    updateCardContext(updatedContext);
  };

  const setAuditBatchId = (auditBatchId: string) => {
    const updatedContext: ChatBulkAuditResultsAdapterContext = {
      ...context,
      auditBatchId,
    };
    updateCardContext(updatedContext);
  };

  useEffect(() => {
    updateCardCanSubmit(
      (context.filter && isValidFilterGroup(context.filter)) || !!context.auditBatchId,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.filter, context.auditBatchId]);

  return {
    card,
    filter: context.filter,
    setFilter,
    auditBatchId: context.auditBatchId,
    setAuditBatchId,
    hasError: !!error,
  };
}

export default useChatBulkAuditResultsAdapterCard;
